import React from 'react';
import { Toggle } from 'carbon-components-react';

const Notifications: React.FC<Props> = ({ user, updateUserProfile }) => {
  const notifyFulfilled =
    user?.notification_setting?.notified_enquiry_fulfill_have_response;

  const handleToggleChange = (val: boolean) => {
    const notification_setting = user.notification_setting;
    const data = {
      notification_setting: {
        ...notification_setting,
        notified_enquiry_fulfill_have_response: val
      }
    };
    updateUserProfile(data);
  };

  return (
    <div id="notifications" className="notifications spacing-padding">
      <div className="sub-section-title">Notifications</div>
      <div className="toggle-container">
        <div>
          <Toggle
            aria-label="Notify me if a response is received after an enquiry is fulfilled"
            id="notify-me-toggle"
            labelA=""
            labelB=""
            size="sm"
            defaultToggled={notifyFulfilled}
            className="toggle-custom-style"
            onToggle={(val: boolean) => handleToggleChange(val)}
          />
        </div>
        <div>
          Notify me if a response is received after an enquiry is fulfilled
        </div>
      </div>
    </div>
  );
};

interface Props {
  user: any;
  updateUserProfile: Function;
}

export default React.memo(Notifications);
